// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyCby-9tpiIQdMAP7lcAGcii6nvUvxVh7iM',
    authDomain: 'niwi-ai-mobile-app.firebaseapp.com',
    databaseURL:
      'https://niwi-ai-mobile-app-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'niwi-ai-mobile-app',
    storageBucket: 'niwi-ai-mobile-app.appspot.com',
    messagingSenderId: '80740292131',
    appId: '1:80740292131:web:604129066f6742640f8396',
    measurementId: 'G-WF63G8ELEB',
    vapidKey:
      'BFloCHzbIK7BHpWNSTtakr3U-gS1eZ7JkOcYz1Sc0D1EapFRi2fUIDCn-SXs2BlP3P_OqLrdPk8RGsu1Jc0SPnI',
  },
  api: {
    image_url: 'https://dev-hub.niwi.ai/assets/uploads/niwiai_images/',
    url: 'https://dev-hub.niwi.ai/',
    dev_url: 'https://dev.niwi.ai/',
    razorpay_key: 'rzp_test_TaDqL1UYGrEHlB',
    merchant_id: '113981',
    package_url: 'https://dev-hub.niwi.ai/assets/uploads/packages/',
  },
  shop: {
    enableKart: true,
  },
  app: {
    app_url: 'https://dev.diet.niwi.ai',
    /* Even numbers only */
    appVersion: '1.9.0', // ODD numbers only
  },
  firestoreCollection: 'chats_dev',
  website_Url: 'https://niwi.ai',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
